import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Input from '../reusable/Input';
import CheckBox from '../reusable/CheckBox';
import Button from '../reusable/Button';
import { Caption, H3 } from '../../styled/typograpghy.styled';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';

const StyledFrom = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 480px;
  @media only screen and (max-width: 568px) {
    width: 100%;
    padding: 0 24px;
  }
`;

const StyledH3 = styled(H3)`
  color: ${({ theme }) => theme.color.white};
  padding-bottom: 40px;
  @media only screen and (max-width: 568px) {
    width: 312px;
    font-size: 20px;
    padding-bottom: 32px;
  }
`;

const StyledAnchor = styled.a`
  color: #ff2976;
`;

const RegistrationForm = ({
  register,
  handleSubmit,
  errors,
  isValid,
  onSubmit,
  checked,
  handleOnChange,
  serverError,
}) => (
  <FlexContainer flexDirection="column" alignItems="center">
    <StyledH3>Peergame Partners Registration</StyledH3>
    <StyledFrom onSubmit={handleSubmit(onSubmit)}>
      <FlexItem margin="0 0 26px 0" width="100%" mobileMargin="0 0 26px 0">
        <Input name="name" inputType="text" label="Name" error={errors} ref={register} modalInputActive />
      </FlexItem>
      <FlexItem margin="0 0 26px 0" width="100%" mobileMargin="0 0 26px 0">
        <Input
          name="email"
          inputType="email"
          label="Email"
          error={errors}
          ref={register}
          modalInputActive
          serverError={serverError}
        />
      </FlexItem>
      <FlexItem margin="0 0 26px 0" width="100%" mobileMargin="0 0 26px 0">
        <Input
          name="sot"
          label="Source of Traffic ( Website, Blog, Social Media )"
          error={errors}
          inputType="text"
          ref={register}
          modalInputActive
        />
      </FlexItem>
      <FlexContainer width="100%" padding="0 0 33px 0">
        <CheckBox name="terms" checked={checked} onChange={handleOnChange}>
          <Caption padding="0 0 0 8px" fontWeight="normal" margin="0">
            I have read and agree with{' '}
            <StyledAnchor as={Link} to="terms-and-conditions" className="bold">
              terms and conditions
            </StyledAnchor>{' '}
            &{' '}
            <StyledAnchor as={Link} to="/privacy-policy" className="bold">
              privacy policy
            </StyledAnchor>
          </Caption>
        </CheckBox>
      </FlexContainer>
      <Button type="submit" disabled={!isValid || !checked || serverError} className="bold">
        JOIN NOW
      </Button>
    </StyledFrom>
  </FlexContainer>
);

RegistrationForm.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default RegistrationForm;
